import { render } from "./TitleHeader.vue?vue&type=template&id=68dbf694"
const script = {}
script.render = render

export default script